var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title is-1"},[_vm._v("403")]),_c('h2',{staticClass:"subtitle is-2"},[_vm._v("Unauthorized Access")])])])])
}]

export { render, staticRenderFns }